import { storageCostBatchCanRecalculateWarehouse, newStorageCostBatchCanRecalculateWarehouse } from "@/api/finance";

// 下拉选择
export class SELECT {
  static TYPE_ALL = [
    { id: "shipment", text: '货件补货' },
    { id: "adjustment", text: '库存调整' },
    { id: "init", text: '期初库存' },
    { id: "init_adjustment", text: '期初调整' },
    { id: "customer_return", text: '买家退货' },
  ]
  static STATUS_ALL = [
    { id: "not_start", text: '未开始' },
    { id: "deducting", text: '扣减中' },
    { id: "already_deducted", text: '已扣完' },
  ]
  static SELECT_INPUT = [
    { id: "relevanceCode", text: '单据号' },
    { id: "shipmentId", text: '货件号' },
    { id: 'batchNumber', text: '批次号' }
  ]
}

// true:已经初始化的仓库，false:未初始化的仓库
export const SELECT_WAREHOUSE = async (init) => {
  let res = await storageCostBatchCanRecalculateWarehouse(init) || []
  return res
}

// 重算弹框下拉仓库列表
export const NEW_SELECT_WAREHOUSE = async () => {
  let res = await newStorageCostBatchCanRecalculateWarehouse() || []
  return res
}

